import { render, staticRenderFns } from "./trouble-is-gb-whatsapp-safe.vue?vue&type=template&id=6f2d1b8e"
import script from "./trouble-is-gb-whatsapp-safe.vue?vue&type=script&lang=js"
export * from "./trouble-is-gb-whatsapp-safe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports